import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import ProductCarousel from "@/components/ProductCarousel";
import ProductQuickView from "@/components/ProductQuickView";
import usePageMeta from "@/lib/useSeo";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function Products() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [saleItems, setSaleItems] = useState([]);
  const [featuredItems, setFeaturedItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [search, setSearch] = useState(params.get("q") || "");
  const [quickSlug, setQuickSlug] = useState(null);
  const activeCat = params.get("cat") || "";

  usePageMeta({
    title: `${activeCat || "All Products"} · Vape Essence`,
    description:
      "Browse disposable vapes and nicotine pouches from Elf Bar, ZYN, VAAL, VELO, GeekBar and more. Fast delivery in South Africa.",
  });

  useEffect(() => {
    const q = {};
    if (activeCat) q.category = activeCat;
    if (params.get("q")) q.search = params.get("q");
    api.get("/products", { params: q }).then((r) => setProducts(r.data));
  }, [activeCat, params]);

  useEffect(() => {
    api.get("/products/categories").then((r) => setCats(r.data));
    api
      .get("/products", { params: { on_sale: true, sort: "newest", limit: 8 } })
      .then((r) => setSaleItems(r.data))
      .catch(() => {});
    api
      .get("/products", { params: { featured: true, sort: "newest", limit: 8 } })
      .then((r) => setFeaturedItems(r.data))
      .catch(() => {});
  }, []);

  const setCat = (c) => {
    const p = new URLSearchParams(params);
    if (c) p.set("cat", c);
    else p.delete("cat");
    setParams(p);
  };
  const doSearch = (e) => {
    e.preventDefault();
    const p = new URLSearchParams(params);
    if (search) p.set("q", search);
    else p.delete("q");
    setParams(p);
  };

  return (
    <div className="mx-auto max-w-[1400px] px-4 py-10 sm:px-6 sm:py-16 lg:px-10">
      <div className="font-label text-xs text-[#00FFC2]">/ SHOP</div>
      <h1 className="mt-3 font-display text-3xl font-black tracking-tighter sm:text-4xl lg:text-5xl">
        {activeCat || "All Products"}
      </h1>

      <div className="mt-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => setCat("")}
            className={`border px-3 py-1.5 font-label text-[11px] transition-colors ${
              !activeCat
                ? "border-[#FF5A1F] bg-[#FF5A1F] text-black"
                : "border-white/15 hover:border-white/40"
            }`}
          >
            All
          </button>
          {cats.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              className={`border px-3 py-1.5 font-label text-[11px] transition-colors ${
                activeCat === c
                  ? "border-[#00FFC2] bg-[#00FFC2] text-black"
                  : "border-white/15 hover:border-white/40"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
        <form onSubmit={doSearch} className="relative w-full md:w-72">
          <MagnifyingGlass
            size={14}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40"
          />
          <input
            type="text"
            placeholder="Search flavours, brands..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border border-white/15 bg-black py-2.5 pl-9 pr-4 text-sm outline-none focus:border-[#FF5A1F]"
          />
        </form>
      </div>

      <div className="mt-8 grid gap-3 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 sm:gap-4">
        {products.length === 0 ? (
          <div className="col-span-full py-32 text-center text-sm text-white/40">
            No products match your filter.
          </div>
        ) : (
          products.map((p, i) => (
            <ProductCard
              key={p.slug}
              product={p}
              index={i}
              onQuickView={(slug) => setQuickSlug(slug)}
            />
          ))
        )}
      </div>

      <ProductQuickView
        slug={quickSlug}
        open={!!quickSlug}
        onClose={() => setQuickSlug(null)}
      />

      <ProductCarousel
        title="On sale now"
        kicker="LATEST DEALS"
        products={saleItems}
        accent="#FFC900"
      />

      <ProductCarousel
        title="Featured picks"
        kicker="STAFF PICKS"
        products={featuredItems}
        accent="#FF5A1F"
      />
    </div>
  );
}
